import { render, staticRenderFns } from "./dingdan-edit.vue?vue&type=template&id=4f386174&scoped=true&"
import script from "./dingdan-edit.vue?vue&type=script&lang=js&"
export * from "./dingdan-edit.vue?vue&type=script&lang=js&"
import style0 from "./dingdan-edit.vue?vue&type=style&index=0&id=4f386174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f386174",
  null
  
)

export default component.exports